module.exports = __webpack_public_path__ + "static/media/route.5ce15b89.svg";